import api from "./api";
class FormaPagamentoService {
    static async getLista() {
        const res = await api.get("/formas-pagamentos/select");
        return res.data;
    }
}
export default FormaPagamentoService;
